/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './TrustedContactsModalMisc.scss';

import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import Store from 'state/Store';
import { touchedField } from 'state/validation/ValidationActions';
import ProfileLabeledInput from '../../ProfileLabeledInput';
import WithUserPermissions from 'components/shared/WithUserPermissions/WithUserPermissions';
import TextInput from 'components/shared/Text/TextInput';
import { isValidEmail, isValidRelationShip } from 'services/Validation';

const EmailWithPermissions = WithUserPermissions(TextInput);
const RelationshipWithPermissions = WithUserPermissions(TextInput);

const TrustedContactsModalMisc = ({
  emailAddress,
  relationship,
  onChange,
  invalidFields,
  touchedFields
}) => {
  const onEmailFieldBlur = () => Store.dispatch(touchedField('emailAddress'));
  const onRelationshipBlur = () => Store.dispatch(touchedField('relationship'));

  const onEmailFieldChange = (event) => {
    const value = event.target.value;
    onChange('emailAddress', 'address')(value);
  };

  const onRelationshipFieldChange = (event) => {
    const value = event.target.value;
    onChange('relationship')(value);
  };

  const emailValidator = (field) => ({
    field,
    shouldValidate: touchedFields[field] === true,
    validator: isValidEmail,
    value: emailAddress.address
  });

  const relationshipValidator = (field) => ({
    field,
    shouldValidate: touchedFields[field] === true,
    validator: isValidRelationShip,
    value: relationship
  });

  return (
    <Fragment>
      <ProfileLabeledInput
        errorMessage={invalidFields['emailAddress']}
        label="Email Address"
        validators={[emailValidator('emailAddress')]}>
        <EmailWithPermissions
          className="trusted-contacts-email-input"
          onBlur={onEmailFieldBlur}
          onChange={onEmailFieldChange}
          value={emailAddress.address}
          shouldMask
        />
      </ProfileLabeledInput>
      <ProfileLabeledInput
        errorMessage={invalidFields['relationship']}
        label="Relationship to Owner"
        validators={[relationshipValidator('relationship')]}
        >
        <RelationshipWithPermissions
          className="relationship-owner-input"
          onBlur={onRelationshipBlur}
          onChange={onRelationshipFieldChange}
          value={relationship}
          shouldMask
        />
      </ProfileLabeledInput>
    </Fragment>
  );
};

TrustedContactsModalMisc.propTypes = {};

const mapStateToProps = (state) => ({
  invalidFields: state.invalidFields,
  touchedFields: state.touchedFields
});

export default connect(mapStateToProps)(TrustedContactsModalMisc);
